import React, { Component } from "react";
import styled from "styled-components";
import { graphql } from "react-apollo";
import PropTypes from "prop-types";
import { mutationUpdateCustomerField } from "Apollo";
import { ShowNotice } from "Store";
import DeleteButton from "./DeleteButtonWithMutation";
import Tooltip from "module-common/Tooltip";
import Icon from "module-common/Icon";

export default graphql(mutationUpdateCustomerField)(
  class FieldRow extends Component {
    static propTypes = {
      customerId: PropTypes.number,
      fieldId: PropTypes.number,
      name: PropTypes.string,
      value: PropTypes.string,
      disabled: PropTypes.bool,
      refetch: PropTypes.func
    };

    componentWillReceiveProps(nextProps) {
      this.input.value = nextProps.value;
    }

    render() {
      const {
        customerId,
        fieldId,
        name,
        value,
        disabled,
        refetch
      } = this.props;

      const labelName =
        name === "Name" ? (
          <Name>{name}</Name>
        ) : (
          <Name>
            {name}
            <Tooltip text={"Press Enter to add " + name}>
              <Icon name="information" width={10} height={10} />
            </Tooltip>
          </Name>
        );

      return (
        <Wrapper>
          {labelName}
          <Colon>:</Colon>
          <form onSubmit={this.onSubmit}>
            <Value
              innerRef={ref => (this.input = ref)}
              type="text"
              readOnly={disabled}
              defaultValue={value}
            />
          </form>
          {!disabled && (
            <StyledDeleteButton
              customerId={customerId}
              fieldId={fieldId}
              refetch={refetch}
            />
          )}
        </Wrapper>
      );
    }

    onSubmit = async event => {
      this.input.blur();
      event.preventDefault();
      const { customerId, fieldId, mutate, refetch } = this.props;
      try {
        await mutate({
          variables: {
            customerInput: { id: customerId },
            customerFieldInput: { id: fieldId },
            content: this.input.value
          }
        });
        refetch();
        ShowNotice("customer-field-update-success");
      } catch (error) {
        ShowNotice("customer-field-update-error");
      }
    };
  }
);

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  position: relative;
  align-items: center;
  margin-bottom: 10px;
`;
const Name = styled.div`
  width: 60px;
  flex: none;
`;
const Colon = styled.div`
  margin-left: auto;
  margin-right: 4px;
`;
const Value = styled.input`
  width: 100%;
  padding: 4px 4px;
  border: none;
  border: 1px solid ${props => props.theme.panelBorder};
  border-radius: 3px;
  ${props =>
    props.readOnly ? "background-color: #efefef" : "padding-right: 22px"};
`;
const StyledDeleteButton = styled(DeleteButton)`
  position: absolute;
  right: 4px;
`;



// WEBPACK FOOTER //
// ./src/module-case-management/info-panel/customer-field/FieldRowWithMutation.js